"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'style.form.title.edit': 'Edytuj Styl Pisania',
    'style.form.title.add': 'Dodaj Styl Pisania',
    'style.form.back': 'Powrót',
    'style.form.name.label': 'Nazwa',
    'style.form.name.placeholder': 'Nazwa stylu',
    'style.form.description.label': 'Opis',
    'style.form.description.placeholder': 'Opisz ten styl pisania',
    'style.form.prompt.label': 'Prompt Stylu',
    'style.form.prompt.placeholder': 'Wprowadź prompt AI, który definiuje ten styl pisania...',
    'style.form.common.label': 'Wspólny Styl',
    'style.form.common.description': 'Wspólne style są dostępne dla wszystkich użytkowników, ale mogą być edytowane tylko przez super administratorów',
    'style.form.active.label': 'Aktywny',
};
